import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  const brand = useBrand();

  if (brand.logos.primary) {
    // w-auto + self-start: in a column flex parent an <img> otherwise stretches to
    // the full width, and an SVG then draws itself centered in that wide box.
    return <img src={brand.logos.primary} alt={brand.company.name} className={`block h-10 w-auto max-w-full self-start ${className}`} />;
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className="w-12 h-12 rounded-lg flex items-center justify-center font-bold text-xl"
        style={{ backgroundColor: brand.colors.primary, color: brand.colors.onPrimary }}
      >
        {brand.company.shortName}
      </div>
      <div className="flex flex-col">
        <span className="font-semibold text-lg leading-tight" style={{ color: brand.colors.secondary }}>
          {brand.company.name.split(' ').slice(0, 2).join(' ')}
        </span>
        <span className="text-sm leading-tight" style={{ color: brand.colors.secondary }}>
          {brand.company.name.split(' ').slice(2).join(' ') || 'INC'}
        </span>
      </div>
    </div>
  );
};
